"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CaviarColors", {
  enumerable: true,
  get: function get() {
    return _caviar.CaviarColors;
  }
});
exports.Themes = void 0;

var _caviar = require("./caviar");

var _merchant = require("./merchant");

// Themes: Overrides Sets
var Themes = {
  Caviar: _caviar.CaviarOverrides,
  Merchant: _merchant.MerchantOverrides
};
exports.Themes = Themes;